import classNames from 'classnames'
import PlusIcon from 'mdi-react/PlusIcon'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Link } from 'utils-next/routes'

import { Button, Theme } from '@mui/material'

import { ScoutingCampaignFilters } from '../../components/ScoutingCampaignFilters'
import { SCOUTING_CAMPAIGN_MANAGER_NEW_USER } from '../../ScoutingCampaignManager.routes'
import { useScoutingCampaignListViewStore } from './ScoutingCampaignListViewStore'

export type CorporateListViewActionsProps = {
  className?: string
}

export function ScoutingCampaignListViewActions({ className }: CorporateListViewActionsProps) {
  const {
    state: { filters },
    actions: { setFilters },
  } = useScoutingCampaignListViewStore()
  const { classes } = useStyles()
  return (
    <div className={classNames(className, classes.container)}>
      <ScoutingCampaignFilters filters={filters} onChange={setFilters} />
      <Link className={classes.button} to={SCOUTING_CAMPAIGN_MANAGER_NEW_USER}>
        <Button variant="contained" size="small" color="secondary">
          <PlusIcon size="24" />
          Create new Space
        </Button>
      </Link>
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  container: {
    display: 'flex',
  },
  button: {
    textDecoration: 'none',
    marginLeft: spacing(2),
  },
}))
